import MainMenu from './MainMenu';

// This module instantiates the menu and makes a reference to it available
// for import by other modules, allowing its public methods to be acted upon.

export const mainMenu = new MainMenu({
	menu 			: '#menu',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	triggers 		: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	triggerEvent 	: 'click',
	collapsable: {
	 	duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen'
	}
});

